export const RECORD_I18N_ENTRIES = {
  record_Data1: {
    es: '<p><span>Ubica</span> la cámara o móvil en el salpicadero del vehículo y graba el tramo de la <span>carretera</span></p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
};
